export default {
  address: 'Addresse *',
  'create-account-247-support': 'Assistance 24h/24',
  'create-account-secure': '100% Sécurisé',
  'create-account-fast': 'Retraits rapides et faciles',
  'create-account-gambling-commission': 'Gambling Commission',

  'create-account-promotion-amount': '##AMOUNT##',
  'create-account-promotion-type': 'Bonus de Bienvenue de',
  'create-account-promotion-description': `jusqu'à ##UPTO_AMOUNT## sur votre premier dépôt`,
  'create-account-promotion-spins-bonus': '+ ##SPINS_AMOUNT## tours gratuits',

  //need translations!
  'create-account-promotion-sign-in': 'Vous avez déjà un compte ?',
  'create-account-close': 'proche',

  'create-account-promotion-terms-row':
    '<a href="/playerprotection">18+.</a> <a href="/promotions?scrollto=welcome_promoterms" class="ui-link">Des conditions s`appliquent.</a> Veuillez jouer de manière responsable. <a href="http://www.gamblingtherapy.org/fr" target="_blank">www.Gamblingtherapy.org</a>',
  'create-account-promotion-terms-fi':
    '<a href="/index.php?page=promotions&amp;scrollto=welcome_promoterms" class="ui-link">Voir les conditions et détails des promotions</a>',

  'personal-details-title': 'S’inscrire',
  'personal-details-supporting-text': 'Seulement 3 étapes simple',
  'address-details-title': 'Presque là',
  'address-details-supporting-text': 'Ici ca va vite',
  'account-details-title': '%firstname%',
  'account-details-supporting-text': 'C’est la dernière étape!',

  'marketing-preferences-title': 'Préférences de communication',
  'marketing-preferences-description':
    'Ursa Casino propose à sa communauté de joueurs des offres quotidiennes et des promotions mensuelles uniques tels que des Bonus de dépôt, des tours Bonus, des tours gratuits, des offres de cashback, des tournois, des classements, des prix réels, des expériences et des vacances. Pour en savoir plus, veuillez sélectionner les options ci-dessous:',
  'marketing-preferences-post-text':
    'Vous pouvez mettre à jour vos préférences de communication à tout moment dans votre section "Mon compte".',
  'marketing-preferences-label-cross-brand': 'Je souhaite connaître les offres exclusives du réseau de votre casino.',
  'marketing-preferences-label-brand-only': 'Je souhaite connaître les offres exclusives de votre casino uniquement.',
  'marketing-preferences-label-email': 'Je souhaite connaître les offres par <strong>e-mail</strong>',
  'marketing-preferences-label-sms': 'Je souhaite connaître les offres par <strong>sms</strong>',
  'marketing-preferences-label-phone-call': 'Je souhaite connaître les offres par <strong>téléphone</strong>',
  'marketing-preferences-label-post': 'Je souhaite connaître les offres par <strong>courrier</strong>',

  'marketing-preferences-unified-description':
    'Ne manquez pas les dernières promotions et offres exclusives de Ursa Casino et des marques de <a href="/brands" target="_blank">notre réseau</a>. Choisissez comment vous souhaitez recevoir nos communications.',
  'marketing-preferences-unified-label-email': 'e-mail',
  'marketing-preferences-unified-label-sms': 'sms',
  'marketing-preferences-unified-label-phone-call': 'Téléphone',
  'marketing-preferences-unified-label-phone-post': 'Courrier',
  terms_and_conditions_ont:
    "<a href='/playerprotection'>19+</a>. soumis à conditions. <a href='/promoterms'>jeu responsable.</a> <a href='http://ConnexOntario.ca/'>ConnexOntario.ca</a>",
  'marketing-preferences-pre-text': 'Choisissez comment recevoir vos bonus, promotions et mises à jour.',
  'marketing-preferences-cross-marketing-description':
    'Je souhaite recevoir des messages promotionnels de notre <a href="/brands" target="_blank">grandissante famille</a> de casinos en ligne par les mêmes canaux.',
  'marketing-preferences-contact-options-email': 'Courriel',
  'marketing-preferences-contact-options-sms': 'SMS',
  'marketing-preferences-contact-options-phone': 'Téléphone',
  'marketing-preferences-label-email-ontario': 'E-mail',
  'marketing-preferences-label-sms-ontario': 'SMS',
  'marketing-preferences-label-phone-ontario': 'Teléphone',
  'marketing-preferences-label-post-ontario': 'Courier',
  'personal-details-button-text-ontario': 'Continuer',
  'personal-details-title-ontario': 'Inscription',
  'display-ontario': 'Définir des Limites ',
  'hoverText-deposit-ontario':
    'Les limites de dépôt quotidiennes, hebdomadaires et mensuelles sont respectivement de 24 heures, sept jours et 28 jours. Elles seront calculées rétroactivement pour la période sélectionnée.',
  'hoverText-losslimit-ontario':
    "Les limites de pertes quotidiennes sont calculées sur 24 heures (c'est-à-dire de 00:00 à 23:59 dans une journée), les limites de pertes hebdomadaires sur 7 jours (c'est-à-dire du lundi 00:00 au dimanche 23:59) et les limites mensuelles sur un mois calendaire (c'est-à-dire de 00:00 le premier jour du mois à 23:59 le dernier jour du mois).",
  'personal-details-supporting-text-ontario': 'En 3 simples Étapes<br>Les champs marqués * sont obligatoires',
  'first-name-ontario': 'Prénom *',
  'middle-name-ontario': 'Deuxième Nom',
  'last-name-ontario': 'Nom de Famille *',
  'preferred-name-ontario': 'Alias',
  'gender-ontario': 'Sexe *',
  'please-select-ontario': 'Veuillez Choisir',
  'period-please-select-ontario': 'Ajouter Limite',
  'value-please-select-ontario': 'Ajouter Valeur',
  'occupation-please-select-ontario': 'Ajouter Occupation',
  'gender-male-ontario': 'Homme',
  'gender-female-ontario': 'Femme',
  'gender-other-ontario': 'Je préfère ne pas dire',
  'birth-date-ontario': 'Date de Naissance *',
  'date-format-ontario': 'Jour, Mois, Année',
  'show-ontario': 'Montrer',
  'hide-ontario': 'Cacher',
  'deposit-limit-ontario': 'Limites de Dépôt',
  'loss-limits-ontario': 'Limites de Pertes',
  'country-ontario': 'Pays *',
  'state-ontario': "Etat/Territoire de L'Union *",
  'daily-ontario': 'Quotidiennes',
  'weekly-ontario': 'Hebdomadaires',
  'monthly-ontario': 'Mensuelles',
  'no-limit-ontario': 'Sans Limite',
  'personal-identity-number-ontario': `Numéro d'Identité Personnelle`,
  'personal-identity-number-help-text-ontario': '',
  'address-details-continue-ontario': 'Continuer',
  'address-details-title-ontario': 'Salut, %firstname%',
  'address-details-supporting-text-ontario': 'Informations Personelles<br>Les champs marqués * sont obligatoires',
  'email-ontario': 'Email *',
  'phone-ontario': 'Numéro de Téléphone *',
  'address-ontario': 'Addresse *',
  'citizenship-ontario': 'Citoyenneté',
  'occupations-state-ontario': 'Situation Professionnelle *',
  'sow-status-label-1-ontario': 'Employé(e)',
  'sow-status-label-2-ontario': 'Travailleur Indépendant',
  'sow-status-label-3-ontario': 'Sans Emploi',
  'sow-status-label-4-ontario': 'Retraité(e)',
  'occupations-ontario': 'Occupation *',
  'company-ontario': 'Société',
  'company-address-ontario': 'Adresse de la Société',
  'company-city-ontario': 'Ville de la Société',
  'company-zip-ontario': 'Code Postal de la Société',
  'company-province-ontario': 'Province de la Société',
  'company-phone-ontario': 'Téléphone de la Societé',
  'sign-up-ontario': 'S’Inscrire',
  'account-details-title-ontario': 'Presque Là',
  'account-details-supporting-text-ontario': 'Information de Compte<br>Les champs marqués * sont obligatoires',
  'username-ontario': `Nom d'Utilisateur*`,
  'username-help-text-ontario': 'Utilisez entre 6 et 20 lettres et chiffres, en minuscules et sans espaces.',
  'password-ontario': 'Mot de Passe *',
  'password-help-text-ontario': 'Utilisez au moins 8 caractères',
  'currency-ontario': 'Devise *',
  'mandatory-field-ontario': 'Les champs marqués * sont obligatoires',
  'only-characters-format': "Aucun caractère spécial ni chiffre n'est autorisé",
  'characters-numbers-format': "Aucun caractère spécial n'est autorisé",
  'postalCode-format-rules-ont':
    "<ul>Validation du code postal :<li>Format : A1A 1A1 </li><li>'A' signifie lettre</li><li>'1' signifie chiffre</li></ul>",
  'deposit-custom-footer':
    "<ul><li class='safe-support'>Assistance 24h/24</li><li class='one-hundred-percent-secure'>100% Sécurisé</li><li class='usp-fast'>Retraits rapides et faciles</li></ul>",
};
